export class RoleSessions {
    static GCL_SES_ROLE = 'GCL-SES-Assume-Role'
}

export default RoleSessions
